import * as Dropdown from "../Dropdown"
import { useCombobox } from "./Root"
import { styled } from "../styles"
import { flexCss } from "../Flex"

type ContentOwnProps = Readonly<{
  valueSerializer?: (value: unknown) => string
}>

export type ContentProps = ContentOwnProps & React.ComponentPropsWithoutRef<typeof Dropdown.Root>

const Content: React.FC<ContentProps> = ({ onValueSelect, valueSerializer, ...dropdownProps }: ContentProps) => {
  const { state, dispatch } = useCombobox(`Content`)

  return (
    <StyledContent>
      <Dropdown.Root
        open={state.open}
        onValueSelect={(value: string | null) => {
          dispatch({ type: `selectItem`, item: value })
          dispatch({ type: `setInputValue`, value: undefined })
          onValueSelect?.(value)
        }}
        {...dropdownProps}
      >
        <Dropdown.Content>
          {Object.entries(state.items).map(([key, value]) => {
            if (typeof value !== `string`) {
              if (valueSerializer !== undefined) {
                return (
                  <Dropdown.Item value={valueSerializer(value)} key={key}>
                    {valueSerializer(value)}
                  </Dropdown.Item>
                )
              }

              throw new Error(`You need to supply a valueSerializer if the values are not strings`)
            }

            return (
              <Dropdown.Item value={value} key={key}>
                {value}
              </Dropdown.Item>
            )
          })}
        </Dropdown.Content>
      </Dropdown.Root>
    </StyledContent>
  )
}

const StyledContent = styled.div({
  ...flexCss,
  position: `absolute`,
  zIndex: 2,
  flexDirection: `column`,
  width: `100%`,
})

Content.displayName = `ComboboxContent`

export { Content }
